export default __webpack_public_path__ + "static/media/icon_locations_active.c67aed83.svg";